import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=31533ba5&scoped=true&"
import script from "./activities.vue?vue&type=script&lang=js&"
export * from "./activities.vue?vue&type=script&lang=js&"
import style0 from "./activities.vue?vue&type=style&index=0&id=31533ba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31533ba5",
  null
  
)

export default component.exports